export default __webpack_public_path__ + "a11cf286a857a64e094efddb338fdd17.svg";